export const defaultProps = {
    isPopup: false,
    isOpen: false,
    theme: 'ios',
    value: '0.00 0.00 1',
    showFooter: true,
    showHeader: true,
    showCaption: true,
    dateConfig: [
        {
            format: 'YYYY',
            caption: 'Sphere',
            step: 1,
            type: 'sphere'
        },
        {
            format: 'M',
            caption: 'Cylinder',
            step: 1,
            type: 'cylinder'
        },
        {
            format: 'D',
            caption: 'Count',
            step: 1,
            type: 'count'
        }
    ],
    confirmText: 'Set',
    cancelText: 'Cancel',
    onSelect: () => {},
    onCancel: () => {},
};



